import { Link } from 'react-router-dom';
import { categories, siteInfo } from '@/mocks/comics';

export default function Footer() {
  return (
    <footer className="bg-background-950 text-foreground-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-5">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4 whitespace-nowrap cursor-pointer">
              <div className="w-8 h-8 flex items-center justify-center">
                <i className="ri-book-open-line text-2xl text-primary-400"></i>
              </div>
              <span className="text-lg font-heading font-bold text-foreground-50">
                {siteInfo.name}
              </span>
            </Link>
            <p className="text-sm text-foreground-400 leading-relaxed">
              {siteInfo.tagline}
            </p>
            <p className="text-sm text-foreground-400 leading-relaxed mt-2">
              收录数千部精品韩漫，免费在线阅读，支持下拉式流畅体验。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-50 mb-4">
              漫画分类
            </h4>
            <ul className="space-y-2.5">
              {categories.filter((c) => c.slug !== 'all').slice(0, 6).map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-50 mb-4">
              热门推荐
            </h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/comic/my-beloved-empress" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">
                  我的爱妃
                </Link>
              </li>
              <li>
                <Link to="/comic/dragon-king-reborn" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">
                  龙王重生
                </Link>
              </li>
              <li>
                <Link to="/comic/sword-of-destiny" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">
                  天命之剑
                </Link>
              </li>
              <li>
                <Link to="/comic/mystery-detective-kim" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">
                  侦探金先生
                </Link>
              </li>
              <li>
                <Link to="/comic/magic-academy-life" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">
                  魔法学院日常
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-50 mb-4">
              关于我们
            </h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/about" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">
                  品牌介绍
                </Link>
              </li>
              <li>
                <a href="mailto:contact@hanmanonline.com" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">
                  联系我们
                </a>
              </li>
              <li>
                <span className="text-sm text-foreground-400">
                  邮箱：contact@hanmanonline.com
                </span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-foreground-800 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} {siteInfo.name} 版权所有 | 免费韩国漫画在线阅读平台
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-300 transition-colors cursor-pointer" rel="nofollow">
              服务条款
            </a>
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-300 transition-colors cursor-pointer" rel="nofollow">
              隐私政策
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}